import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PredictorModelState } from 'src/app/state/predictor-model/predictor-model.state';
import { TerrainLoadingStatus } from '../../enums/terrain-loading-status';

@Component({
  selector: 'app-terrain-status',
  templateUrl: './terrain-status.component.html',
  styleUrls: ['./terrain-status.component.scss'],
})
export class TerrainStatusComponent {
  @Select(PredictorModelState.demFileUploadStatus)
  demFileUploadStatus$!: Observable<number>;

  @Select(PredictorModelState.demFileLoading)
  demFileUploading$!: Observable<boolean>;

  @Select(PredictorModelState.terrainLoadingStatus)
  terrainLoadingStatus$!: Observable<TerrainLoadingStatus>;

  isTerrainStatusFailed(terrainLoadingStatus: TerrainLoadingStatus | null): boolean {
    return [
      TerrainLoadingStatus.FailedOnCheckingStatus,
      TerrainLoadingStatus.FailedOnDownload,
      TerrainLoadingStatus.FailedOnUpload
    ].includes(terrainLoadingStatus as TerrainLoadingStatus);
  }

  getUploadStatus(demFileUploadStatus: number | null): string {
    return demFileUploadStatus == null || demFileUploadStatus < 100
      ? `Uploading - ${demFileUploadStatus ?? 0}%`
      : 'Processing';
  }
}
